import { Toast } from 'react-vant';
import client from './ClientOld';

/**
 * 高阶函数，用于注入依赖
 * @param {Function} t - 国际化翻译函数
 * @param {Object} i18n - 国际化对象
 * @returns {Function} - 实际的请求函数
 */

const createClientRequest = (t, i18n) => {
  return async (requestData) => {
    return new Promise((resolve, reject) => {
      let callName = `cb_${Date.now()}_${Math.random().toString().slice(2)}`;
      client.registerBridgeApi(callName, (param) => {
        if (!param) return;
        let { code, data } = JSON.parse(decodeURIComponent(param));
        if (code != 200) {
          switch (code) {
            case -1001:
              Toast.info(t('text163'));
              break;
            case -1002:
              Toast.info(t('text22'));
              break;
            case -1003:
              Toast.info(t('text23'));
              break;
            case -1000:
              Toast.info(t('text24'));
              break;
            default:
              Toast.info(t('text25'));
              break;
          }
          // Toast.show({ content: `${typeof param} ${param}`, duration: 50000 });
          return reject({ code: code });
        }
        let response = JSON.parse(data);
        let { error, errorCode, errorMessage, resultBodyObject } = response;
        if (errorCode === 0 || !error) {
          return resolve(response);
        }
        switch (errorCode) {
          case -1:
            Toast.info(t('text163'));
            break;
          case 500001:
            Toast.info(t('text26'));
            break;
          case 500012:
            Toast.info(t('text27'));
            break;
          case 502504:
            Toast.info(t('text27'));
            break;
          case 502506:
            Toast.info(t('text28'));
            break;
          case 503001:
            break;
          case 500000:
            Toast.info(t('text29'));
            break;
          // SIM 卡管理专属错误码(后端契约: sim-management-h5-frontend.md)
          case 501608:
            Toast.info(t('text147'));
            break;
          case 501609:
            Toast.info(t('text148'));
            break;
          case 501610:
            // SIMBOSS 业务错误:由页面自行展示后端 errorMessage
            break;
          case 501611:
            Toast.info(t('text152'));
            break;
          default:
            Toast.info(t('text30'));
            break;
        }
        return reject(response);
      });
      let params = JSON.stringify({ operateId: callName, data: JSON.stringify(requestData) });
      client.getApi('proxyRequest', encodeURIComponent(params));
    });
  };
};

export default createClientRequest;
